import { useState } from "react";
import { config } from "../utils";

const AboutComp = () => {
  const [showmore, setMore] = useState(true)
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row d-flex align-items-start g-4">
          {/* Image Column */}
          <div className="col-lg-4 wow fadeIn" data-wow-delay="0.1s">
            <div className="position-relative h-100">
              <img
                className="img-fluid w-100 h-100 object-fit-cover"
                src="img/about.jpg"
                alt="About Us"
                style={{ borderRadius: "10px", objectFit: "cover", height: "100%" }}
              />
            </div>
          </div>

          {/* Text Column */}
          <div className="col-lg-8 wow fadeIn" data-wow-delay="0.5s">
            <div className="ps-lg-4">
              <h1 className="text-primary mb-4">About {config.appName}</h1>

              <p>
                In 2011, a group of visionary individuals in Chennai, India, embarked on a humble journey to transform the lives of underprivileged children. This initiative, Maitri, was born out of a deep passion to provide a nurturing environment where young minds could flourish.</p>

              <p>
              We are a registered organization under Section 12AA, with 80G Exemptions and our CSR number is CSR00047960.
              </p>

              <p>
              Maitri is committed to delivering holistic education that goes beyond academics. We believe that every child deserves to be empowered with self-confidence, self-reliance, and good character.
              </p>

              {showmore && (
                <p className="text-primary" onClick={() => {
                  setMore(!showmore)
                }}>{showmore ? `show more` : `show less`}</p>
              )}
              {!showmore && (<>
              <p>At Maitri, we're dedicated to bridging the educational gap for children from economically disadvantaged backgrounds. Our approach is built on three core pillars:</p>
                <ul>
                  <li><strong>Care:</strong> We provide a safe, supportive, and inclusive environment that fosters emotional growth and well-being.</li>

                  <li><strong>Concern:</strong> We're committed to addressing the unique needs of each child, ensuring they receive the attention and resources they deserve.</li>
                  <li><strong>Commitment:</strong> We're dedicated to helping our children become capable, compassionate, and responsible individuals who can make a positive impact in their communities.</li>


                </ul>
                <p>
                By joining hands with us, you can be part of a transformative journey that changes lives. Together, let's empower the next generation of leaders, thinkers, and change-makers.
                </p>
              </>)}
              {!showmore && (
                <p className="text-primary" onClick={() => {
                  setMore(!showmore)
                }}>{showmore ? `Show More` : `Show Less`}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutComp;
